import { useQuery } from "@apollo/client";

import { useReviewVisitPanelStatus } from "../../../hooks/useReviewVisitPanelStatus";
import { ProjectReviewVisitV2FinalReportRoute_GetDataDocument } from "../queries.generated";

export function useProjectReviewVisitV2FinaReportRoute_GetData(visitId: string) {
    const { data, loading, error, previousData, startPolling, stopPolling } = useQuery(
        ProjectReviewVisitV2FinalReportRoute_GetDataDocument,
        {
            variables: {
                visitId,
            },
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-first",
        },
    );

    const result = loading ? previousData : data;
    const visit = result?.plannerV2VisitGetById;
    const weatherReport = result?.plannerVisitWeatherReportGetByVisitId;
    const ecologicalFunctions = result?.ecologicalFunctionsByVisitGetAll.data;
    const observations = result?.observationsGetAllForFinalReport;
    const preciseLocationForm = result?.settingsFormTemplateGetMasterForm;

    const { panelStatus, isEverythingReady } = useReviewVisitPanelStatus(result);

    return {
        visit,
        ecologicalFunctions,
        panelStatus,
        isEverythingReady,
        weatherReport,
        observations,
        preciseLocationForm,
        loading,
        error,
        startPolling,
        stopPolling,
    };
}
